module.exports = __webpack_public_path__ + "static/media/book_fantasy_thumb.2693581c.png";